import type { LibraryItemStatus } from "./types";

export const buildMyLibraryReturnTo = ({
  itemId,
  search,
  categoryIds,
  statusFilters,
  sortBy,
}: {
  itemId?: string | null;
  search?: string;
  categoryIds?: string[];
  statusFilters?: LibraryItemStatus[];
  sortBy?: string;
}) => {
  const next = new URLSearchParams();
  if (itemId) next.set("item", itemId);
  if (search?.trim()) next.set("q", search.trim());
  if (categoryIds?.length) next.set("categories", categoryIds.join(","));
  if (statusFilters?.length) next.set("status", statusFilters.join(","));
  if (sortBy && sortBy !== "recent") next.set("sort", sortBy);
  const query = next.toString();
  return `my-library${query ? `?${query}` : ""}`;
};

export const resolveReturnToHref = (returnTo: string) => {
  if (!returnTo) return "";
  if (returnTo.startsWith("my-library:")) return `/my-library?item=${returnTo.replace("my-library:", "")}`;
  if (returnTo.startsWith("my-library") || returnTo.startsWith("excerpts") || returnTo.startsWith("readwise-highlights")) {
    return `/${returnTo}`;
  }
  return "";
};
